var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:( _obj = {'controls-subscribe': true, dark: _vm.isDark, disabled: _vm.isDisabled}, _obj[_vm.size] = _vm.size, _obj ),attrs:{"disabled":_vm.isDisabled},on:{"click":_vm.toggleSubscribe}},[_c('IconShare'),_vm._v(" "),_c('span',[_vm._v("Share & Subscribe")])],1)
var _obj;}
var staticRenderFns = []

export { render, staticRenderFns }